export default __webpack_public_path__ + "static/media/b2bEmail.916d2d11.png";